import React, { Component } from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";
//import "bootstrap/dist/css/bootstrap.min.css";
import CreatableSelect from "react-select/creatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt} from "@fortawesome/free-solid-svg-icons";

/*
const createOption = (label) => ({
  label,
  value: label,
});
*/

const createOption = (idName) => (
  {label: idName.name, value: idName.id }
);

export default class ModalIdNameListDialog extends Component 
{
  constructor() {
    super();
    this.state = {
      mapValues: null,
      newValue: null,
      dropOptions: [],
      errMsg: "",
      saving: false
    };

    this.onOkButtonClick = this.onOkButtonClick.bind(this);
    
  }

  componentDidUpdate(prevProps, prevState)
  {
    if (prevProps.show !== this.props.show)
    {
      if (this.props.show)
      {
        // initializing the dialog
        var newDropOptions = (this.props.dataList) ? 
        this.props.dataList.map(l => {return createOption(l)})
        : [{label: "No Options Available", value: ""}];

        this.setState({
          dropOptions: newDropOptions,
          errMsg: "",
          saving: false
        });
      }
    }
  }

  handleChange = (newValue, actionMeta) => {
    console.group('Value Changed');
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    if ((actionMeta.action === 'select-option') || (actionMeta.action === 'create-option') || (actionMeta.action === 'clear'))
    {
      this.setState({
        errMsg: "",
        newValue: newValue
      });
    }
  };
  handleInputChange = (inputValue, actionMeta) => {
    console.group('Input Changed');
    console.log(inputValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    this.setState({errMsg: ""});
  };



  onOkButtonClick(e) 
  {
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.newValue || this.state.newValue.value.trim().toLowerCase()==="")
    {
      this.setState({errMsg: "Select a new value."})
      return;
    }
    if (this.state.newValue.value.trim().toLowerCase() === this.props.existingValue?.id?.toLowerCase())
    {
      this.setState({errMsg: "It looks like you didn't change the value? Cancel if you do not want to continue"});
      return;
    }
    this.setState({
      errMsg: "",
      saving: true
    });
    this.props.onModalOkRequest(this.props.existingValue?.id, this.state.newValue.value);
  }

  render() {
    //console.info(this.props.dataRow);

    const savingDiv = (this.state.saving) ?
    <div><FontAwesomeIcon icon={faSyncAlt} spin={true} color={"green"}/>&nbsp; Saving...</div>
    : "";



    return (

      (this.props.show) ?
      <Modal
        show={this.props.show} 
        onHide={this.props.onModalCloseRequest}
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Row><Col>Current  Value: {(this.props.existingValue?.name) ? this.props.existingValue.name: ""}</Col></Row>
        <Row>&nbsp;</Row>
          <Row>
            <Col>
              <CreatableSelect
                autoFocus
                isClearable
                placeholder={this.props.placeholder}
                defaultValue={createOption(this.props.existingValue)}
                onChange={this.handleChange}
                onInputChange={this.handleInputChange}
                options={this.state.dropOptions}
              />
            </Col>
          </Row>
          <Row style={{color: "red", fontSize: "11px"}}>{this.state.errMsg}</Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={(e) => this.onOkButtonClick(e)}
          >
            Ok
          </Button>
          <Button
            variant="secondary"
            onClick={(e) => this.props.onModalCloseRequest(e)}
          >
            Cancel
          </Button>
          <div>
            {savingDiv}
          </div>
        </Modal.Footer>
      </Modal>
      : <span/>
    );
  }
}
